module.exports = __webpack_public_path__ + "static/media/animalCiclo2.a460057a.png";